<template>
  <layout>
    <router-view />
    <div class="container mt-4" v-if="!isInvoiceDetailsRoute">
      <div class="row">
        <div class="col-12">
          <b-card>
            <div v-if="invoices?.length > 0" class="due-container">
              <div class="h-50 d-flex justify-content-center flex-column">
                <p style="font-size: 20px">
                  Balance due: <b>{{ toCurrencyValue(balanceDue) }}</b>
                </p>
                <b-button @click="payAll" variant="success" size="lg"
                  >Pay Bill</b-button
                >
              </div>
            </div>

            <div
              v-if="false"
              class="d-flex flex-row justify-content-center mt-4 mb-4"
            >
              <b-spinner
                style="width: 4rem; height: 4rem"
                variant="primary"
                label="Spinning"
              ></b-spinner>
            </div>

            <b-tabs card class="mt-4">
              <b-tab title="Invoices" :active="showPendingInvoiceFirst">
                <table class="portal-table portal-table-responsive">
                  <thead>
                    <tr>
                      <th>{{ $t("date") }}</th>
                      <th>Status</th>
                      <th>{{ $t("invoice") }}</th>
                      <th>{{ $t("charges") }}</th>
                      <th>{{ $t("payments") }}</th>
                      <th>{{ $t("balance") }}</th>
                      <th></th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="item in patientInvoices"
                      :key="item.id"
                      class="portal-table-row"
                    >
                      <td data-label="Creation Date">
                        {{ formatDate(item.createdAt) }}
                      </td>
                      <td
                        data-label="Invoice Status"
                        class="d-flex justify-content-start align-items-center w-100"
                      >
                        <span
                          style="font-size:10px; padding:2px 10px;"
                          class="badge-v2"
                          :class="{
                            'badge-success': invoiceFullyPaid(item),
                            'badge-danger': !invoiceFullyPaid(item)
                          }"
                        >
                          {{ invoiceFullyPaid(item) ? "Paid" : "Unpaid" }}
                        </span>
                      </td>
                      <td data-label="Invoice #">{{ item.refNumber }}</td>
                      <td data-label="Total Amount">
                        {{ toCurrencyValue(item.totalAmount) }}
                      </td>
                      <td data-label="Amount Paid">
                        {{ toCurrencyValue(item.amountPaid) }}
                      </td>
                      <td data-label="Unpaid Amount">
                        {{
                          toCurrencyValue(item.totalAmount - item.amountPaid)
                        }}
                      </td>
                      <td
                        class="cursor-pointer"
                        style="color: #3f77f5"
                        @click="goToInvoiceDetail(item.id)"
                      >
                        View
                        <i
                          class="fas fa-arrow-right"
                          style="color: #3f77f5; font-size: 15px"
                        ></i>
                      </td>
                    </tr>

                    <tr v-if="false">
                      <td colspan="6" align="center">
                        <div
                          class="
                            d-flex
                            flex-row
                            justify-content-center
                            mt-4
                            mb-4
                          "
                        >
                          <b-spinner
                            style="width: 4rem; height: 4rem"
                            variant="primary"
                            label="Spinning"
                          ></b-spinner>
                        </div>
                      </td>
                    </tr>

                    <tr v-if="!loading && invoices.length === 0">
                      <td colspan="6" align="center">NO INVOICES</td>
                    </tr>
                  </tbody>
                </table>
              </b-tab>

              <b-tab
                title="Payment Methods"
                :active="showAddPaymentMethodFirst"
              >
                <patient-payment-methods-add
                  :patientId="patientId"
                  :hideSelect="true"
                  :activeNewCard="showAddPaymentMethodFirst"
                />
              </b-tab>
              <b-tab title="Payment History">
                <table class="portal-table portal-table-responsive">
                  <thead>
                    <tr>
                      <th>{{ $t("date") }}</th>
                      <th>{{ $t("details") }}</th>
                      <th>{{ $t("amount") }}</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="item in patientTransactions"
                      :key="item.id"
                      class="portal-table-row"
                    >
                      <td data-label="Payment Date">
                        {{ formatDate(item.paymentDate) }}
                      </td>
                      <td data-label="Invoice">
                        {{
                          item.transactionsAllocations
                            .map(ta => ta.invoice.refNumber)
                            .join(", ")
                        }}
                      </td>
                      <td data-label="Amount">
                        <span v-if="item.type == 'Payment'">{{
                          toCurrencyValue(item.totalAmount)
                        }}</span>
                        <span v-else
                          >-{{ toCurrencyValue(item.totalAmount) }}</span
                        >
                      </td>
                    </tr>

                    <tr v-if="false">
                      <td colspan="6" align="center">
                        <div
                          class="
                            d-flex
                            flex-row
                            justify-content-center
                            mt-4
                            mb-4
                          "
                        >
                          <b-spinner
                            style="width: 4rem; height: 4rem"
                            variant="primary"
                            label="Spinning"
                          ></b-spinner>
                        </div>
                      </td>
                    </tr>

                    <tr v-if="!loading && patientTransactions.length === 0">
                      <td colspan="6" align="center">NO TRANSACTIONS</td>
                    </tr>
                  </tbody>
                </table>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { defineComponent } from "vue";
import Layout from "../workspace/Layout.vue";
import { billingServer } from "../../server/billing";
import paymentServer from "../../server/payment";
import PatientPaymentMethodsAdd from "./PatientPaymentMethodsAdd.vue";
import { formatDateOnly } from "../../helpers/date";
export default defineComponent({
  name: "Billing",
  components: { Layout, PatientPaymentMethodsAdd },
  props: {
    reload: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      invoices: [],
      transactions: [],
      loading: false,
      showPendingInvoiceFirst: false,
      showAddPaymentMethodFirst: false
    };
  },
  async mounted() {
    this.loading = true;
    this.fetchStates();
    await this.getPatientInvoices();
    await this.getPatientTransactions();

    if (this.$route.name === "AddPaymentMethod") {
      this.showAddPaymentMethodFirst = true;
      this.showPendingInvoiceFirst = false;
    } else {
      this.showAddPaymentMethodFirst = false;
      this.showPendingInvoiceFirst = true;
    }
  },
  computed: {
    ...mapState("session", {
      patientId: state => state.user.PatientId
    }),
    patientInvoices() {
      return this.invoices;
    },
    patientTransactions() {
      return this.transactions;
    },
    balanceDue() {
      if (this.invoices.length > 0) {
        return this.invoices.reduce(
          (acc, invoice) => acc + (invoice.totalAmount - invoice.amountPaid),
          0
        );
      }
    },
    isInvoiceDetailsRoute() {
      return this.$route.matched.some(
        route =>
          route.name === "InvoiceDetails" || route.name === "InvoicePayment"
      );
    }
  },
  methods: {
    ...mapActions("client", ["fetchStates"]),
    goToInvoiceDetail(id) {
      this.$router.push({
        name: "InvoiceDetails",
        params: { invoiceId: id }
      });
    },
    payAll() {
      this.$router.push({
        name: "InvoicePayment",
        params: {
          invoices: this.invoices.filter(
            invoice => !this.invoiceFullyPaid(invoice)
          )
        }
      });
    },
    async getPatientInvoices() {
      await billingServer
        .getInvoices(this.patientId)
        .then(response => {
          if (response.status === 200) {
            this.invoices = response.data;
            this.loading = false;
          }
        })
        .catch(error => {
          console.log(error);
          this.loading = false;
        });
    },
    async getPatientTransactions() {
      await paymentServer
        .query({
          patientId: [this.patientId],
          paymentType: [],
          orderBy: "createdAt",
          orderByDescending: true
        })
        .then(response => {
          this.transactions = response.data.transactions;
        })
        .catch(error => {
          console.log(error);
          this.loading = false;
        });
    },
    formatDate(date) {
      return formatDateOnly(date);
    },
    invoiceFullyPaid(invoice) {
      return invoice.totalAmount - invoice.amountPaid <= 0;
    }
  },
  watch: {
    $route: {
      async handler() {
        await this.getPatientInvoices();
        await this.getPatientTransactions();
      }
    }
  }
});
</script>

<style scoped>
.due-container {
  background-color: #f5f6f9;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
}

.due-container button {
  font-size: 1.2rem;
  padding: 10px 30px;
  color: white;
  height: 50px;
}
</style>
